export const DefaultTheme = {
    colors: {
        primary: '#000000',
        background: '#FFFFFF',
    },
};
